import { render, staticRenderFns } from "./insertDocument.vue?vue&type=template&id=7378bf08&scoped=true&"
import script from "./insertDocument.vue?vue&type=script&lang=js&"
export * from "./insertDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7378bf08",
  null
  
)

export default component.exports